import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import ActionTable from "../../components/table/ActionTable";
import api from "../../services/api";
import AppContext from "../../container/context";
import { mergeParams } from "../../helpers/helpers";
import Form from "../../components/form";
import menuGrupo from "../../enums/menuGrupo";

export default function Lista({ history, location }) {
  const [carregando, setCarregando] = useState(false);
  const [dados, setDados] = useState(
    mergeParams({ nome: "", sistema: 1, exibirInativos: false }, location)
  );
  const [lista, setLista] = useState([]);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregarMenus();
  }, []);

  const carregarMenus = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);
    setCarregando(true);

    api
      .get("menus/listar", filtrosEnviar)
      .then((res) => {
        setLista(res);
        setCarregando(false);
      })
      .catch((err) => {
        notification("error", "Não foi possível listar menus");
        setCarregando(false);
      });
  };

  const filtros = {
    title: "Filtros",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 6,
        value: dados.nome,
      },
      sistema: {
        label: "Sistema",
        type: "select",
        emptyItem: true,
        space: 4,
        options: [
          {
            value: 0,
            desc: "(Todos)",
          },
          {
            value: 1,
            desc: "Painel Administrativo",
          },
          {
            value: 2,
            desc: "Painel Escolas",
          },
        ],
        value: dados.sistema,
      },
      exibirInativos: {
        label: "Exibir inativos",
        type: "check",
        space: 2,
        value: dados.exibirInativos,
      },
    },

    submit: {
      label: "Buscar",
      action: carregarMenus,
    },

    urlParams: true,
    history,
    location,
  };

  const abrirGrupo = (registro) => {
    history.push(`/app/menu/${registro.id}`);
  };

  const tRegistros = {
    title: "Menus",
    onLineClick: abrirGrupo,
    newItemAction: () => history.push("/app/menu/0"),
    columns: [
      {
        name: "nome",
        label: "Nome",
      },
      {
        name: "menuPaiNome",
        label: "Menu pai",
      },
      {
        name: "grupo",
        label: "Grupo",
        domain: menuGrupo,
      },
    ],
    array: lista,
  };

  return (
    <div>
      <Form formData={filtros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
